import { requiredConfig } from '#/config/appConfigUtils';
import { I18nLocale } from '#/i18n/types/I18nLocale';

import type { AlgoliaSearchArgs } from './algoliaSearch';

export const AlgoliaConfig: Record<string, Partial<AlgoliaSearchArgs>> = {
  CONTENT: {
    indexName: requiredConfig('algolia', 'contentIndexName'),
    options: {
      page: 0,
      hitsPerPage: 50,
      attributesToRetrieve: ['objectID', 'title'],
    },
  },
  NEW_ORG_NAME: {
    indexName: requiredConfig('algolia', 'siteIndexName'),
    options: {
      page: 0,
      hitsPerPage: 20,
      filters: 'type:ORG',
      attributesToRetrieve: ['objectId', 'name'],
    },
  },
  STAFF_ORG_PAYMENTS: {
    indexName: requiredConfig('algolia', 'staffIndexName'),
    options: {
      hitsPerPage: 50,
      page: 0,
      attributesToRetrieve: ['objectID', 'name'],
      filters: 'type:ORG',
      attributesToHighlight: [],
      getRankingInfo: false,
      clickAnalytics: false,
    },
  },
  SALARY_SURVEY_TITLES: {
    indexName: requiredConfig('algolia', 'compdbIndexName'),
    options: {
      attributesToRetrieve: ['name', 'jobTitle'],
      filters: 'includeInSurvey:true',
      hitsPerPage: 20,
      ignorePlurals: true,
      page: 0,
      queryLanguages: [I18nLocale.EN],
      removeStopWords: true,
      removeWordsIfNoResults: 'allOptional',
    },
  },
  SALARY_REPORT_SURVEY_TITLES: {
    indexName: requiredConfig('algolia', 'compdbIndexName'),
    options: {
      attributesToRetrieve: ['name', 'jobTitle'],
      filters: 'includeInSurvey:true',
      hitsPerPage: 20,
      ignorePlurals: true,
      page: 0,
      queryLanguages: [I18nLocale.EN],
      removeStopWords: true,
      removeWordsIfNoResults: 'allOptional',
    },
  },
  STAFF_SALARY_SURVEY_TITLES: {
    indexName: requiredConfig('algolia', 'compDbStaffIndexName'),
    options: {
      page: 0,
      hitsPerPage: 50,
      attributesToRetrieve: ['name', 'subFamilyId'],
    },
  },
  STAFF_CONTENT_POSTS: {
    indexName: requiredConfig('algolia', 'contentStaffIndexName'),
    options: {
      page: 0,
      hitsPerPage: 20,
      attributesToRetrieve: ['objectID', 'subsiteId', 'pages'],
      filters: 'type:CMS_PAGE_MASTER AND pages.status:PUBLISHED',
    },
  },
};
